import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { basketSelectors } from '@store/basket/selectors';
import { entitySelectors } from '@store/entity/selectors';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { fetchingSelectors } from '@store/fetching/selectors';
import { fetchFacility } from '@store/entity/actions';
import { SpaEntityFormSteps } from '@common/components/SpaEntity/SpaEntityFormSteps';
import { Routes } from '@common/constants';
import { EntityTypes } from '@common-types/Entities';
import { FacilityFormStepEnum } from './Facility.types';

const mapStateToProps = (state) => ({
  property: entitySelectors.getProperty(state),
  basketDetails: basketSelectors.getBasketDetails(state),
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
  fetchingDates: fetchingSelectors.facilitiesFetchingDates(state),
  showGenderNeutral: entitySelectors.isSpaShowGenderNeutralEnabled(state),
  isSpaEntityFetching: fetchingSelectors.facilitiesItemFetching(state),
  SpaEntityFormStepEnum: FacilityFormStepEnum,
  entityBookingRoute: Routes.FACILITY_BOOKING,
  entityType: EntityTypes.FACILITY,
  entityLabel: 'spa.facility',
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchSpaEntity: fetchFacility,
    },
    dispatch
  );

export const FacilityFormStepsContainer: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(SpaEntityFormSteps as any);
